export default "/images/italic.svg?b9ef9040fc4d2104b5dab5e8130def31";